import React from 'react';
import type { HomeDashboard, HomeStatus } from '../../../api/homeV3Api';
import styles from '../HomeV3.module.css';

interface Props {
    dashboard: HomeDashboard;
    onSelectStatus: (status: HomeStatus | null) => void;
    onFocusSection: (id: string) => void;
}

export function KpiRibbon({ dashboard, onSelectStatus, onFocusSection }: Props) {
    const cards: { label: string; value: number; status: HomeStatus | null; section: string | null }[] = [
        { label: 'Open requests', value: dashboard.requestSummary.openCount, status: 'open' as const, section: 'recent-requests' },
        { label: 'Completed in 30 days', value: dashboard.requestSummary.completedLast30DaysCount, status: 'completed' as const, section: 'recent-requests' },
        // The exercise panels are not rendered when the team has nothing in
        // progress, so there is no section to jump to — keep the count visible
        // but don't offer a jump that would land nowhere.
        { label: 'Active exercises', value: dashboard.exercises.length, status: null, section: dashboard.exercises.length > 0 ? 'targeting-exercises' : null },
    ];

    return (
        <nav className={styles.kpiRibbon} aria-label="Dashboard summary">
            {cards.map((card) => (
                <button
                    key={card.label}
                    type="button"
                    className={styles.kpiCard}
                    onClick={() => {
                        onSelectStatus(card.status);
                        if (card.section) {
                            onFocusSection(card.section);
                        }
                    }}
                >
                    <span className={styles.kpiLabel}>{card.label}</span>
                    <span className={styles.kpiValue}>{card.value}</span>
                </button>
            ))}
        </nav>
    );
}
